var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.996,
    height: 20,
    viewBox: "0 0 19.996 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close2",
    transform: "translate(-229.7 -198.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8544",
    "data-name": "Path 8544",
    d: "M249.386,198.846a1.054,1.054,0,0,1,.072,1.41l-.072.08L231.5,218.217a1.054,1.054,0,0,1-1.563-1.41l.072-.08,17.882-17.88a1.054,1.054,0,0,1,1.491,0Z",
    transform: "translate(0 -0.178)",
    fill: "#89cff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8545",
    "data-name": "Path 8545",
    d: "M249.412,216.548a1.054,1.054,0,0,1-1.41,1.562l-.08-.072-17.88-17.882a1.054,1.054,0,0,1,1.41-1.563l.08.072,17.881,17.881Z",
    transform: "translate(-0.026 0)",
    fill: "#89cff0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.6bbb590094e0e9f1ad2ae2fda330759c.svg";
export { ForwardRef as ReactComponent };